


























import { Component, Vue, Prop } from 'vue-property-decorator';
import Papa from 'papaparse';
import Encoding from 'encoding-japanese';
import { sessionModule } from '@/trials/store/modules/session';

import ErrorDialogData from '@/trials/exceptions/errorDialogData';

const LIMIT_SIZE = 1024 * 1024;

@Component
export default class DragDrop extends Vue {
    // 属性
    @Prop({ default: 'train' })
    purpose?: string;

    private message: string = '';

    // 関数
    private async onDrop(event: any) {
        try {
            const dropFile = event.target.files
                ? event.target.files[0]
                : event.dataTransfer.files[0];

            // file input をリセット
            this.$refs.fileInput.value = '';

            // バリデーション
            if (dropFile.size > LIMIT_SIZE) {
                const errorDialogData = new ErrorDialogData('error.message.file.size');

                sessionModule.showErrorDialog(errorDialogData);
                return;
            }

            const fileExtention = dropFile.name.split('.').pop();
            if (fileExtention != 'csv') {
                const errorDialogData = new ErrorDialogData('error.message.file.name');

                sessionModule.showErrorDialog(errorDialogData);
                return;
            }

            // file の type を text/csv にする
            const buf = await dropFile.slice();
            let csv;
            try {
                csv = new File([buf], dropFile.name, { type: 'text/csv' });
            } catch (err) {
                // Edgeでは File constructor が使えないため
                // Blobオブジェクトにnameを追加して対応
                csv = new Blob([buf], { type: 'text/csv' });
                csv['name'] = dropFile.name;
            }

            // 投入されたCSVを、API呼び出し前にjsで処理する場合の記述
            const reader = new FileReader();
            reader.onload = async (event: any) => {
                const binaryData = new Uint8Array(event.target.result);

                // 文字コード判定
                const encode = Encoding.detect(binaryData);

                // バイナリデータ⇒UTF-8 文字列型 変換
                const unicodeString = Encoding.convert(binaryData, {
                    to: 'UNICODE',
                    from: encode,
                    type: 'string',
                });

                // UTF-8 文字列型⇒Json文字列 変換
                const jsonString = Papa.parse(unicodeString as string, {
                    header: false,
                    dynamicTyping: true,
                    skipEmptyLines: true,
                }).data;

                // header を storeへ格納し、csv登録処理
                switch (this.purpose) {
                    case 'train':
                        sessionModule.SET_INPUT_TRAINING_DATA_HEADERS(jsonString[0]);
                        await sessionModule.registTrainingSet(csv);
                        break;

                    case 'predict':
                        sessionModule.SET_INPUT_PREDICT_DATA_HEADERS(jsonString[0]);
                        await sessionModule.registPredictSet(csv);
                        break;
                    default:
                        break;
                }
            };

            reader.readAsArrayBuffer(dropFile);
            this.message = '';
        } catch (e) {
            // this.message = e.message;
            console.error(e);
        }
    }
}
